import { Link } from "react-router-dom"
import CriticalIllness from "../components/InsuranceComps.js/CriticalIllness"
import Education from "../components/InsuranceComps.js/Education"

const posts = [
  {
    id: 1,
    title: 'Critical Illness Cover',
    page: "/CriticalIllness",
    description:
      'The Britam Critical Illness Plan is a protection cover designed to provide an extra layer of financial security in the event that one is diagnosed with Critical illness.',
   
   
  },
  {
    id: 2,
    title: 'Education Plans',
    page: "/Education",
    description:
      `The best gift you can ever give your child is a bright future, and in this day and age, a great deal of your child's security lies in financial planning from a tender age. Timely investments are crucial when selecting the ideal education plan for your child.
      Our education plans ultimately help in financial planning for your child's future need and ensures that your child gets the best in the future To help you with this, Britam offers you tailor made solutions that you can choose from.`,
   
   
  },
  {
    id: 3,
    title: 'Funeral Plans',
    page: "/FuneralCover",
    description:
      `A funeral plan is a policy that provides financial support to pay for the policyholder's funeral expenses in the unfortunate event of demise. We work to help remove the stress and financial burden of arranging a funeral from your family and loved ones at the time of most need. It isn’t easy, but it’s necessary. Make plans now so your loved ones will be empowered to fulfill your final wishes.`,
   
   
  },
  {
    id: 4,
    title: 'Health Insurance',
    page: "/HealthInsurance",
    description:
      `Britam offers an array of health insurance solutions. Britam Milele Retail and Kinga Ya Mkulima cover individuals and families , while Britam Milele Corporate, offers a flexible inpatient cover and a fund- managed outpatient cover for employees and their dependants. Britam Milele Corporate is ideal for registered companies, NGOs, as well as Chamas with more than 10 members.`,
   
   
  },
  {
    id: 5,
    title: 'Personal Accident Insurance',
    page: "/PersonalAccident",
    description:
      `Personal Accident insurance  is an annual policy which provides compensation in the event of injuries, disability or death caused solely by violent, accidental, external and visible events.`,
   
   
  },
  {
    id: 7,
    title: 'Home Insurance',
    page: "/HomeInsurance",
    description:
      `Home insurance covers your house and belongings against life's unexpected events. It covers you against theft, damage by extreme weather, fire, and other losses. Generally, home insurance is categorised by two types of cover — buildings and contents. These can be combined or bought separately for total peace of mind, so the first step is deciding which option is better for you.`,
   
   
  },
  {
    id: 7,
    title: 'Motor Insurance',
    page: "/MotorInsurance",
    description:
      `We provide you with financial protection against physical/bodily injury resulting from ownership and/or use of motor vehicles and against liability that could arise from their use. Our motor insurance cover can be used to protect both private and commercial vehicles. What does our cover entail?....`,
   
   
  },
  {
    id: 8,
    title: 'Protect your Income',
    page: "/ProtectIncome",
    description:
      `Britam offers a range of financial products to help you achieve your short and medium-term goals.The Britam Akiba Plan,Dhamana ,Family Income Solution.Learn more...`,
   
   
  },
  // More posts...
]

export default function Insurance() {
  return (
    <div className="text-ternary-dark dark:text-ternary-light  py-24 sm:py-32">
      <div className="mx-auto max-w-7xl px-6 lg:px-8">
        <div className="mx-auto max-w-2xl lg:mx-0">
          <h2 className="text-3xl font-bold tracking-tight  sm:text-4xl">Insure na Mugami</h2>
          <p className="mt-2 text-lg leading-8    ">
            Learn how to grow your business with our expert advice.
          </p>
        </div>
        <div className="mx-auto mt-10 grid max-w-2xl grid-cols-1 gap-x-8 gap-y-16 border-t border-gray-200 pt-10 sm:mt-16 sm:pt-16 lg:mx-0 lg:max-w-none lg:grid-cols-3">
          {posts.map((post) => (
            <article key={post.id} className="flex max-w-xl flex-col items-start justify-between">
              
              <div className="group relative">
                <h3 className="mt-3 text-lg font-semibold leading-6  group-hover:text-gray-600">
                <Link to={post.page}>
                    <span className="absolute inset-0" />
                    {post.title}
                    </Link>
                  
                </h3>
                <p className="mt-5 line-clamp-3 text-sm leading-6    ">{post.description}</p>
              </div>
            
             
            </article>
          ))}
        </div>
      </div>
    </div>
  )
}
